import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../components/core/basic/Modal";
import { DataViewForm, type DataViewFormValues } from "./DataViewForm";

export type SaveDataViewResult = DataViewFormValues;

type SaveDataViewModalProps = {
  existingNames?: readonly string[];
};

export const SaveDataViewModal = NiceModal.create(({ existingNames }: SaveDataViewModalProps) => {
  const modal = useModal();
  const { t } = useTranslation(["dataViews"]);

  const onSubmit = (values: DataViewFormValues) => {
    modal.resolve(values satisfies SaveDataViewResult);
    modal.remove();
  };

  const onCancel = () => {
    modal.resolve(null);
    modal.remove();
  };

  return (
    <Modal
      isOpen={modal.visible}
      isDismissable
      onOpenChange={(isOpen) => !isOpen && onCancel()}
      title={t(($) => $.dataViews["Save view"])}
      css={{ minWidth: "480px" }}
    >
      <DataViewForm
        submitLabel={t(($) => $.dataViews["Save view"])}
        onSubmit={onSubmit}
        onCancel={onCancel}
        existingNames={existingNames}
      />
    </Modal>
  );
});
